import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-goal-task',
  templateUrl: './goal-task.component.html',
  styleUrls: ['./goal-task.component.scss']
})
export class GoalTaskComponent implements OnInit {

@Input() taskFormGroup: FormGroup;
@Input() taskId: number;
@Input() taskName: string;
@Input() taskDueDate: string;
@Input() action: 'confirm' | 'update' | 'delete' = 'confirm';

@Output() deleteTask = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  getTaskNumber() {
    return this.taskId + 1;
  }

  onDeleteTask() {
    this.deleteTask.emit(this.taskId);
    console.log("Delete Task emitted.");
  }

}
